export default "__VITE_ASSET__dcoS6_Ln__"